import { reactive } from "vue";

export const globalState = reactive({
  modal: {
    isOpen: false,
    toolId: null,
    categories: [],
  },

  openModal(toolId, categories) {
    this.modal.toolId = toolId;
    this.modal.isOpen = true;
    this.modal.categories = categories;
    // Disable body scroll when modal is open
    document.body.style.overflow = "hidden";
  },

  closeModal() {
    this.modal.isOpen = false;
    this.modal.toolId = null;
    this.modal.categories = [];
    // Enable body scroll
    document.body.style.overflow = "";
  },


});
